import React from 'react';

const CroixSvg = ({width = 20, height = 20}) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 20 20" fill="none">
        <path d="M5 5L15.6452 15.6452" stroke="#002335" strokeWidth="2" strokeLinecap="round"
              strokeLinejoin="round"/>
        <path d="M5 15.6445L15.6452 4.99937" stroke="#002335" strokeWidth="2" strokeLinecap="round"
              strokeLinejoin="round"/>
    </svg>
);

export default CroixSvg;
